import React, { CSSProperties } from 'react';
import { Star } from 'lucide-react';

interface InterestedButtonProps {
  eventId: number;
  isAttending: boolean;
  attendeeCount: number;
}

/**
 * InterestedButton for web - READ-ONLY
 * Links to app download page instead of performing RSVP
 */
export const InterestedButton: React.FC<InterestedButtonProps> = ({
  isAttending,
}) => {
  const handleClick = () => {
    window.location.href = '/download';
  };

  return (
    <button
      style={styles.button}
      onClick={handleClick}
      type="button">
      {isAttending ? (
        <Star size={18} fill="white" color="white" style={styles.icon} />
      ) : (
        <Star size={18} color="white" style={styles.icon} />
      )}
      <span style={styles.text}>Interested</span>
    </button>
  );
};

const styles: Record<string, CSSProperties> = {
  button: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#4a7bb7',
    borderRadius: '20px',
    padding: '10px 20px',
    minWidth: '100px',
    border: 'none',
    cursor: 'pointer',
    transition: 'opacity 0.2s',
  },
  icon: {
    marginRight: '6px',
  },
  text: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 600,
  },
};
